import { render, staticRenderFns } from "./mGameResultDetail.vue?vue&type=template&id=419917fd&scoped=true"
import script from "./mGameResultDetail.vue?vue&type=script&lang=js"
export * from "./mGameResultDetail.vue?vue&type=script&lang=js"
import style0 from "./mGameResultDetail.vue?vue&type=style&index=0&id=419917fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419917fd",
  null
  
)

export default component.exports